var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"almox-motivo-recusa","rota-base":"/admin/almox-motivo-recusa","titulo-singular":"Motivo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }